<script>
import {mapActions} from 'vuex';
import { useAlert } from 'dashboard/composables';

export default{
  name: 'RenameDocModal',
  props: {
    name: {
      type: String
    }
  },
  data(){
    return{
      nameLocal: '',
      isRenaming: false,
    }
  },
  methods: {
    ...mapActions('dify', ['renameDocument']),
    async rename(){
      try{
        this.isRenaming = true;
        await this.renameDocument({
          datasetId: this.$route.params.id,
          documentId: this.$route.params.documentId,
          payload: {
            name: this.nameLocal
          }
        });
        useAlert('Document name updated successfully');
        this.$emit('close');
        this.$emit('refresh');
      }catch(err){
        console.error(err);
      }finally{
        this.isRenaming = false;
      }
    }
  },
  mounted(){
    this.nameLocal = this.name;
  }
}
</script>

<template>
  <div class="fixed inset-0 z-40 flex items-center justify-center p-4">
    <div class="fixed inset-0 z-40 bg-slate-800/20 dark:bg-slate-900/60"></div>

    <div 
      class="bg-white dark:bg-slate-800 dark:text-slate-100 p-4 rounded-md fixed z-50 transition-all duration-300 ease-in-out flex flex-col w-[560px] top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2"
      @click.stop
    >
    <h4 class="text-lg font-semibold mb-2">{{ $t('KNOWLEDGE.RENAMEDOCMODAL.TITLE') }}</h4>

      <label class="text-sm mb-4">
        {{ $t('KNOWLEDGE.RENAMEDOCMODAL.NAME_LABEL') }}
        <input 
          type="text" 
          v-model="nameLocal" 
          class="w-full mt-1 px-2 py-1 rounded border border-gray-300 dark:border-slate-600 dark:bg-slate-700 dark:text-white"
        />
      </label>

      <div class="flex gap-4 justify-end mt-4">
        <woot-button color-scheme="secondary" :disabled="isRenaming" @click="$emit('close')">{{ $t('KNOWLEDGE.RENAMEDOCMODAL.CANCEL_BUTTON') }}</woot-button>
        <woot-button :disabled="isRenaming" @click="rename">{{ isRenaming ? $t('KNOWLEDGE.RENAMEDOCMODAL.SAVING') : $t('KNOWLEDGE.RENAMEDOCMODAL.CONFIRM_BUTTON') }}</woot-button>
      </div>
    </div>
  </div>
</template>